export * from './plugin';
export * from './decorators';
export * from './util';
export * from './ionic-native-plugin';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic-native/core/index.js
// module id = 199
// module chunks = 7